import React, { useState, useEffect, useCallback, useContext } from "react";
import { useAlert } from "react-alert";
import { ApiService } from "../../../services/ApiService";
import { Calendar, momentLocalizer } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { ConfirmTemplate } from "../../../components/confirm";
import moment from "moment";
import CreateHoliday from "./create_holiday";
import EditHoliday from "./edit_holiday";
import useModal from "../../../utils/useModal";
import Modal from "react-modal";
import styled from "styled-components";
import { systemConfigThunk } from "../../../store/actions/systemconfiguration/systemconfig.thunk";
import { useDispatch, useSelector } from "react-redux";
import { AuthContext } from "../../../Context/AuthContext";
import { PageBody } from "../../../components/loader";
import { useLoadingMessage } from "../../../components/useLoadingMessage";

const Styles = styled.div`
  .rbc-row-content {
    z-index: 0;
  }
`;

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "50%",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    // border: "2px solid green",
  },
};

Modal.setAppElement("#root");

export const CalendarIndex = () => {
  const localizer = momentLocalizer(moment);
  const alert = useAlert();
  const { isLoading, message, updateLoader } = useLoadingMessage();

  const [holidays, setHolidays] = useState([]);
  const [category, setCategory] = useState([]);
  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [open, setOpen] = useState(false);

  const { modalIsOpen, openModal, closeModal } = useModal();

  const { eventCat } = useSelector((state) => state.systemConfig);
  const dispatch = useDispatch();
  const { user } = useContext(AuthContext);
  const openEditModal = () => {
    setOpen(true);
  };

  const closeEditModal = () => {
    setOpen(false);
  };

  const request = async () => {
    updateLoader(true, "Loading calender");
    const getcategory = await ApiService.get("holidays");
    setHolidays(getcategory.data.holidays);
    setCategory(getcategory.data.categories);
    updateLoader(false);
  };

  const deleteHoliday = (id) => {
    const deleterequest = async () => {
      const request_id = {
        holiday_id: id,
      };

      const res = await ApiService.delete(`holidays/delete-holiday/${id}`);
      if (res.data.type === false) {
        alert.error(res.data.msg);
      } else if (res.data.type === true) {
        alert.success(res.data.msg);
      }
      request();
    };
    ConfirmTemplate(
      {
        title: "Delete Holiday",
        message: "Are You Sure You Want To Delete This Holiday",
      },
      deleterequest
    );
  };

  const getRoles = useCallback(async () => {
    updateLoader(true, "Loading calender");
    await dispatch(systemConfigThunk.getEventCat());
    updateLoader(false);
  }, [dispatch]);

  useEffect(() => {
    getRoles();
  }, []);

  useEffect(() => {
    request();
  }, []);

  return (
    <React.Fragment>
      <PageBody isLoading={isLoading} message={message}>
        <Modal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          style={customStyles}
          contentLabel="create event modal"
        >
          <CreateHoliday
            closeModal={closeModal}
            alert={alert}
            categoryType={eventCat}
            getRequest={request}
          />
        </Modal>
        <Modal
          isOpen={open}
          onRequestClose={closeEditModal}
          style={customStyles}
          contentLabel="create event modal"
        >
          <EditHoliday
            closeModal={closeEditModal}
            alert={alert}
            categoryType={category}
            getRequest={request}
            data={data}
            deleteHoliday={deleteHoliday}
          />
        </Modal>
        <div className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box-two">
                  <h4 className="page-title"></h4>
                  <h1 className="welcome_text">CALENDAR</h1>
                  <div className="clearfix"></div>
                </div>
              </div>
            </div>

            <nav
              className="navbar navbar-light navbar-expand-md bg-faded justify-content-center"
              style={{ backgroundColor: "#243050" }}
            >
              <h3 className="text-white">CALENDER EVENT</h3>
              <a href="/" className="navbar-brand d-flex w-50 mr-auto"></a>
            </nav>

            <div class="row">
              <div class="col-sm-12 col-md-12 col-xs-12">
                <div class="cad-box">
                  <div class="row">
                    <div class="col-md-3">
                      {(user.data.user.roles &&
                        user.data.user.roles.name === "admin") ||
                      user.data.user.roles.name === "human resource" ? (
                        <a
                          onClick={openModal}
                          style={{ backgroundColor: "#243050" }}
                          class="btn btn-lg btn-primary btn-block waves-effect m-t-20 waves-light"
                        >
                          <i class="fa fa-plus"></i> &nbsp;&nbsp; Create a new
                          event
                        </a>
                      ) : null}

                      <div id="accordion">
                        {category.map((cat, i) => (
                          <div>
                            <h4
                              // onClick={toggle}
                              style={{ color: "#000" }}
                              key={i}
                            >
                              {cat.name}
                            </h4>
                            {/* {showDown ? ( */}
                            <div>
                              {holidays.map((hol, j) =>
                                cat.id === hol.event_cat_id ? (
                                  <div
                                    id="holiday_list_{{$holiday->id}}"
                                    class="external-event bg-dark"
                                    key={j}
                                    style={{ color: "#ffffff" }}
                                  >
                                    <i class="mdi mdi-checkbox-blank-circle m-r-10 vertical-middle"></i>
                                    {hol.name}
                                  </div>
                                ) : null
                              )}
                            </div>
                            {/* ) : null} */}
                          </div>
                        ))}
                      </div>
                    </div>
                    <div class="col-md-9" id="">
                      <div class="panel-body">
                        <div
                          style={{ height: "500px", backgroundColor: "#fff" }}
                        >
                          <Calendar
                            localizer={localizer}
                            onSelectEvent={(e) => {
                              setData(e);
                              openEditModal();
                            }}
                            defaultDate={new Date()}
                            events={holidays.map((hol, i) => ({
                              title: hol.name,
                              start: new Date(hol.start_date),
                              end: new Date(hol.end_date),
                              cat: hol.event_cat_id,
                              id: hol.id,
                            }))}
                            startAccessor="start"
                            endAccessor="end"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* </div>
                    </div> */}
          </div>
        </div>
      </PageBody>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/container/dashboard/calendar/index.js